import { i18n } from '@/tools/i18n';
import logger from '@/tools/logger';

import { mutationTypes, getterTypes, actionTypes, errorTypes, articleTypes } from '@/types';
import { meaning, PACKAGE_SYNCER_MODES, syncActionStates } from '@/tools/consts';
export default {
	state: {
		active: false,
		current: null,
		tourCurrentID: null,
		position: null,
		toursMap: {},
		tourEntryArticleID: null,
		tourEntryExhibitionID: null,
	},
	mutations: {
		/**
		 *	This mutations stets current tour if position is set its stats at this position
		 * @param {*} state
		 * @param {tourID, position} options
		 */
		[mutationTypes.tourSetCurrent](state, { tourID, position }) {
			state.tourCurrentID = tourID;
			state.current = state.toursMap[tourID];
			state.active = true;
			state.position =
				typeof position === 'number' && position < state.current.exhibitIDs.length ? position : 0;
		},
		/**
		 * This mutations sets current and
		 * @param {*} state
		 */
		[mutationTypes.tourEnd](state) {
			state.current = null;
			state.tourCurrentID = null;
			state.active = false;
			state.position = null;
		},
		/**
		 * This mutation adds if tour-overview article to exhibition and tour if needed
		 * and checks if every article in tour is published if not its removeing it from exhibitList.
		 * @param {*} state
		 * @param { tours } options
		 */
		[mutationTypes.tourInit](state, { tours, exhibitionMap }) {
			// remove tours of not published exhibitions
			const avaibleTours = tours.filter((tour) => exhibitionMap[tour.exhibitionID]);
			// remove not published articles of tour to prevent crashes
			avaibleTours.forEach((tour) => {
				tour.exhibitIDs = tour.exhibitIDs.filter((exhibit) =>
					exhibitionMap[tour.exhibitionID].articles.find((entry) => entry[0] === exhibit.articleID)
				);
			});
			state.toursMap = avaibleTours.reduce((acc, tour) => {
				tour.id = tour._id;
				if (tour.addOverview) {
					tour.exhibitIDs.unshift({ articleID: `tour-${tour.id}-list`, isSharable: tour.isSharable });
					exhibitionMap[tour.exhibitionID].articles.push([
						`tour-${tour.id}-list`,
						{
							pageTheme: 'article-list',
							id: `tour-${tour.id}-list`,
							name: `tour-${tour.id}-list`,
							type: articleTypes.tourList,
							languageContent: tour.languageContent,
							isShareable: tour.isShareable,
							triggers: [],
						},
					]);
				}
				acc[tour.id] = tour;
				return acc;
			}, {});
		},
		/**
		 * This mutation sets the tour position
		 * @param {*} state
		 * @param { position } options
		 */
		[mutationTypes.tourSetPosition](state, { position }) {
			state.position = position;
		},
		/**
		 * This muations sets set entry article which will be loaded when the tour ends
		 * @param {*} state
		 * @param { exhibitionID, articleID } options
		 */
		[mutationTypes.tourSetEntryArticle](state, { exhibitionID, articleID }) {
			state.tourEntryExhibitionID = exhibitionID;
			state.tourEntryArticleID = articleID;
		},
	},
	actions: {
		/**
		 * This action starts a tour , currentArticle in
		 * currentExhibition will be stored. If tour ends it will loade state.tourEntryArticleID.
		 * @param {*} store
		 * @param { tourID, position } options
		 */
		async [actionTypes.tourStart](
			{ commit, dispatch, state, rootState },
			{ tourID, articleID, noOfflineSync }
		) {
			const tour = state.toursMap[tourID];
			if (!state.toursMap[tourID]) {
				dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownTour) });
				return;
			}

			if (
				!noOfflineSync &&
				rootState.packageSyncer.isSyncerApp &&
				rootState.packageSyncer.mode === PACKAGE_SYNCER_MODES.tour &&
				rootState.packageSyncer.subPartStates[tourID] !== syncActionStates.loaded
			) {
				commit(mutationTypes.sendMessage, {
					type: meaning.info,
					body: i18n.t(`error.${errorTypes.packageSyncerTourNotDownloaded}`),
				});
				return;
			}
			// do not set entry article if articleID is set, beacause jump into specifig articl

			if (!articleID && !tour.tourEntryArticleID) {
				commit(mutationTypes.tourSetEntryArticle, {
					exhibitionID: rootState.currentExhibitionID,
					articleID: rootState.currentArticleID,
				});
			}
			dispatch(actionTypes.pushUrl, {
				url: `/${tour.exhibitionID}/tour/${tourID}/${articleID ? articleID : tour.exhibitIDs[0].articleID}`,
				replace: false,
			});
		},
		/**
		 * This actions load next article of tour if last one is allready reach tour will be ended
		 * @param {*} store
		 */
		[actionTypes.tourNext]({ dispatch, state }) {
			if (!state.current) {
				dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.tourNotActive) });
				return;
			}
			// Tour has next article
			if (state.position + 1 < state.current.exhibitIDs.length) {
				dispatch(actionTypes.pushUrl, {
					url: `/${state.current.exhibitionID}/tour/${state.current.id}/${
						state.current.exhibitIDs[state.position + 1].articleID
					}`,
					replace: false,
				});
			} else {
				dispatch(actionTypes.tourEnd);
			}
		},
		/**
		 * This actions load previous article of tour if first one is allready reach tour will be ended
		 * @param {*} store
		 */
		[actionTypes.tourPrevious]({ dispatch, state }) {
			if (!state.current) {
				dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.tourNotActive) });
				return;
			}
			// Tour has next article
			if (state.position - 1 >= 0) {
				dispatch(actionTypes.pushUrl, {
					url: `/${state.current.exhibitionID}/tour/${state.current.id}/${
						state.current.exhibitIDs[state.position - 1].articleID
					}`,
					replace: false,
				});
			} else {
				dispatch(actionTypes.tourEnd);
			}
		},
		/**
		 * This action ends tour and loads entryArticlID if set
		 * fallback one is landing page of entryExhibtionID
		 * fallback to exhibtion Landing of tour exhibtion
		 * @param {*} store
		 */
		[actionTypes.tourEnd]({ commit, dispatch, state, rootState }, { doNotRedirect = false } = {}) {
			commit(mutationTypes.setNavigation, {
				navigation: {
					tour: [],
				},
			});
			commit(mutationTypes.tourEnd);
			if (doNotRedirect) return;
			// If an tourEntryArticle is set, this happens e.g. if user clicks  on a tour start button
			if (state.tourEntryArticleID && state.tourEntryExhibitionID) {
				dispatch(actionTypes.pushUrl, {
					url: `/${state.tourEntryExhibitionID}/${state.tourEntryArticleID}?endTour=1`,
					replace: false,
				});
				// No tour EntryArticle was set check if tour EntryExhibition was set.
			} else if (state.tourEntryExhibitionID) {
				dispatch(actionTypes.pushUrl, {
					url: `/${state.tourEntryExhibitionID}?endTour=1`,
					replace: false,
				});
			} else {
				// if no tour Entry exhibition was set fallback use landing page of exhibition which the tour is part of
				const { exhibitionID, articleID } = rootState.dataSourceCFG.global.landingExhibit;
				dispatch(actionTypes.pushUrl, {
					url: `/${exhibitionID}/${articleID}?endTour=1`,
					replace: false,
				});
			}
		},
		/**
		 *This action jumps to this position of the tour
		 * @param {*} store
		 * @param { position } options
		 */
		[actionTypes.tourJumpToPosition]({ dispatch, state }, { position }) {
			if (state.current.exhibitIDs.length < position || position < 0) {
				dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.tourInvalidPosition) });
				return;
			}
			dispatch(actionTypes.pushUrl, {
				url: `/${state.current.exhibitionID}/tour/${state.current.id}/${state.current.exhibitIDs[position].articleID}`,
				replace: false,
			});
		},
		/**
		 * This actions set the tour navigation
		 * @param {*} store
		 */
		[actionTypes.tourSetNavigation]({ commit, dispatch, state }) {
			if (!state.current) {
				logger.warn('tourSetNavigation failed because state.current.exhibitIDs are missing');
				return;
			}
			const isTourEnd = state.position == state.current.exhibitIDs.length - 1;
			const isTourBeginning = state.position === 0;
			const tourNavigation = [
				{
					name: isTourBeginning ? 'close' : 'previous',
					place: 'tour',
					showIn: '*',
					class: 'control',
					url: '[function]',
					contentID: isTourBeginning ? 'end' : 'previous',
					click: () => {
						if (isTourBeginning) dispatch(actionTypes.tourEnd);
						else dispatch(actionTypes.tourPrevious);
					},
				},
				{
					name: 'title',
					place: 'tour',
					showIn: '*',
					data: {
						'data-position': 'store://state.tour.position',
						'data-length': 'store://state.tour.current.exhibitIDs.length',
					},
					content: 'store://getters[getterTypes.tourCurrentArticle].languageContent.title',
				},
			];
			if (!(isTourEnd && state.current.endTourOnlyOnCommand)) {
				tourNavigation.push({
					name: isTourEnd ? 'end' : 'next',
					place: 'tour',
					showIn: '*',
					class: 'control',
					url: '[function]',
					contentID: isTourEnd ? 'end' : 'next',
					click: () => {
						if (isTourEnd) dispatch(actionTypes.tourEnd);
						else dispatch(actionTypes.tourNext);
					},
				});
			}
			if (state.current.endTourOnlyOnCommand) {
				tourNavigation.push({
					name: 'endTour',
					place: 'tour',
					class: 'control',
					showIn: '*',
					contentID: 'endTour',
					click: () => {
						dispatch(actionTypes.tourEnd);
					},
				});
			}
			commit(mutationTypes.setNavigation, {
				navigation: {
					tour: tourNavigation,
				},
			});
		},
	},
	getters: {
		[getterTypes.nextLocationIDs](state, getters, rootState) {
			if (!state.current) return new Set();
			const nextPosition = state.position + 1;
			if (nextPosition >= state.current.exhibitIDs.length) return new Set();
			return new Set(
				rootState.dataSourceCFG.exhibitionMap[state.current.exhibitionID].articleMap[
					state.current.exhibitIDs[nextPosition].articleID
				].triggers.map(({ locationID }) => locationID)
			);
		},
		[getterTypes.tourCurrentArticle](state, getters, rootState) {
			if (!rootState.dataSourceCFG) return null;
			const currentPosition = state.position >= 0 ? state.position : 0;
			if (state.current === null) return null;
			const article =
				rootState.dataSourceCFG.exhibitionMap[state.current.exhibitionID].articleMap[
					state.current.exhibitIDs[currentPosition].articleID
				];
			return article;
		},
	},
};
